<template>
  <SubContent h="550px" @back="showTip = true">
    <template v-slot:nav_left>
      <p>上传证明材料</p>
    </template>
    <div class="mediaFormWrap">
      <vue-scroll>
        <el-form
          ref="formData"
          :model="formData"
          :rules="formRules"
          class="demo-form-inline"
          label-width="155px"
        >
          <el-row>
            <el-form-item label="证明材料列表" prop="description">
              <el-input
                v-model="formData.description"
                type="textarea"
                :rows="4"
                placeholder="请列出您提交的证明材料文件名称"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="证明材料" :error="uploadErroeMsg" :rules="{required: true}">
              <el-upload
                class="upload-demo"
                multiple
                :limit="9"
                :on-success="handleSuccess"
                action="/api/zuxie/guozi/upload/uploadJixiaoFile"
                :before-upload="handleBeforeUpload"
                :on-error="handleError"
                :on-remove="handleRemove"
                :on-exceed="handleExceed"
                :file-list="uploadFileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: white; line-height: 15px; font-size: 14px">
                  请上传证明材料（例如：官方录取通知、官方报名秩序册可证明球员参与集训），单个文件不超过50M，最多上传9个文件。
                </div>
              </el-upload>
            </el-form-item>
          </el-row>
        </el-form>
      </vue-scroll>
    </div>
    <template v-slot:btn>
      <div class="btn_wrap_media">
        <el-button type="primary" style="margin-right: 20px" :disabled="disabled" @click="checkForm" >提交 </el-button>
        <el-button type="danger" @click="showTip = true">取消</el-button>
      </div>
    </template>
    <yioks-tip
      :showTip="showTip"
      tipMsg="本次本次集训的球员名单已提交上海足协审核，确定放弃修改证明材料并返回吗?"
      @callback="goBack"
    ></yioks-tip>
    <yioks-tip
        :showTip="showSucessTip"
        tipMsg="确定提交证明材料吗？在官方审核之前您可以随时删除或新增参与本次集训的球员名单。如官方审核通过或者拒绝，将无法编辑修改。"
        @callback="addRecordProve"
    ></yioks-tip>
  </SubContent>
</template>

<script>
import recordVerify from "@/utils/formRules/record";
import storage from "@/utils/storage";
import record from '@/api/record'
export default {
  name: "addRecordProve",
  components: {
    SubContent: () => import("@/components/layout/contentWithbtn"),
  },
  mixins: [recordVerify],
  data() {
    return {
      img: "",
      type: "",
      recordUuid: this.$route.query.recordUuid || "",
      recordYouthUuid: this.$route.query.recordYouthUuid || "",
      recordProveInfo: {}, // 机构证明材料信息
      recordName: '', // 赛事名称
      playerObj: {},
      showTip: false,
      showSucessTip: false,
      disabled: false,
      userRole: storage.get("userInfo").userRole,
      formData: {
        description: "", //描述
        recordProveFileList: [], // 文件
      },
      tips: "",
      uploadErroeMsg: "", // 文件上传信息校验
      uploadFileList: [], // 文件上传组件 - 文件列表
      uploadFileList_edit: [], // 文件上传组件 - 编辑中新增文件
      fileListChangedFlag: false,
    };
  },
  created() {
    // 获取详情接口
    this.getRecordProveInfo();
  },
  filters:{},
  methods: {
    // 编辑获取详情
    getRecordProveInfo() {
      record.getRecordProveInfo(this.recordUuid,this.recordYouthUuid,'trainCamp').then((res) => {
          if (res.uuid) {
            const { uuid,recordUuid, recordYouthUuid, recordType, description,recordProveFileList } = res;
            this.type = "edit"
            this.recordProveInfo = res;
            this.formData = {description,recordProveFileList}

            // 处理已上传文件列表
            if (recordProveFileList && recordProveFileList.length) {
              this.uploadFileList = [];
              this.uploadFileList = recordProveFileList.map((item) => {
                const { fileName, fileUrl, uuid } = item;
                return {
                  name: fileName,
                  url: fileUrl,
                  id: uuid,
                  meta: item,
                };
              });
            }
          }
      });
    },

    // 取消按钮
    goBack(isSure) {
      if (isSure) {
        this.$router.push({
          path: 'youthPlayerList',
          query: {
            uuid: this.recordUuid
          }
        })
      }
      this.showTip = false;
    },

    // 确认提交验证
    checkForm() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.uploadErroeMsg = "";
          // 编辑状态下不校验原始证明材料
          if (!this.formData.recordProveFileList.length && this.type !== "edit") {
            this.uploadErroeMsg = "请上传证明材料";
            return; // 无证明材料不允许 提交
          }
          // 编辑状态下需要检测原始文件和修改文件列表同时不为空，避免用户删除全部文件而不上传新文件
          if (this.type === "edit") {
            if (!this.uploadFileList_edit.length && !this.uploadFileList.length) {
              this.uploadErroeMsg = "请上传证明材料";
              return; // 无证明材料不允许 提交
            }
          }
          this.showSucessTip = true;
        } else {
          this.$message.error("请完善所有带 * 的必填项");
        }
      });
    },

    // 确认提交
    addRecordProve(flag) {
      if (flag) {
        //  编辑模式下修改上传的文件列表 （仅上传新增的文件）
        if (this.type === "edit") {
          if (this.uploadFileList_edit.length) {
            this.$set(this.formData, "recordProveFileList", this.uploadFileList_edit);
          } else {
            // 用户没有新增加文件 - 清空提交文件列表
            this.$set(this.formData, "recordProveFileList", []);
          }
        }

        const data = {
          ...this.formData,
          recordUuid: this.recordUuid,
          recordYouthUuid: this.recordYouthUuid,
          recordType: 'trainCamp',
        };
        let request;
        if (this.type === "edit") {
          request = record.editRecordProve;
          data.uuid = this.recordProveInfo.uuid;
        } else {
          request = record.addRecordProve;
        }
        request(data).then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
          } else {
            // 进入提交列表页面
            this.$router.push({
              path: 'youthPlayerList',
              query: {
                uuid: this.recordUuid
              }
            })
          }
        });
      } else {
        this.showSucessTip = false;
      }
    },


    //  证明材料提交成功
    handleSuccess(res, file) {
      if (this.uploadErroeMsg) this.uploadErroeMsg = "";
      this.fileListChangedFlag = true;
      const { fileMd5, fileName, suffix, url } = res;
      const fileObj = {
        recordUuid: this.recordUuid,
        recordYouthUuid: this.recordYouthUuid,
        recordType: 'trainCamp',
        name: fileName,
        md5: fileMd5,
        url: url,
        fileName: fileName,
        fileUrl: url,
        fileType: suffix
      };
      if (this.type === "edit") {
        this.uploadFileList_edit.push(fileObj);
      }
      this.uploadFileList.push(fileObj);
      this.$set(this.formData, "recordProveFileList", this.uploadFileList);
    },

    // 上传文件检测
    handleBeforeUpload(file) {
      const imageLimit = file.size / 1024 / 1024 < 50;

      if (!imageLimit) {
        this.$message.error("单个上传文件大小不能超过50M");
      }
      return imageLimit;
    },

    handleError(fileList) {
      fileList = [];
      this.$message.error("上传失败");
    },

    // 移除文件
    handleRemove(file, fileList) {
      this.fileListChangedFlag = true;
      const  { meta } = file;
      if(meta && meta.uuid) {
        const {
          meta: { uuid },
        } = file;
        // 异步删除文件后，还需要手动清除当前文件列表
        record.deleteRecordProveFile(uuid)
          .then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
          })
          .catch((err) => {
            console.error("err", err);
          });
        this.uploadFileList = this.uploadFileList.filter((item) => {
          return item.id !== file.meta.uuid;
        });
      } else {
        this.uploadFileList = this.uploadFileList.filter((item) => {
          const  status = file.url !== item.url;
          return status
        })
      }
      this.$set(this.formData, "recordProveFileList", this.uploadFileList);
      if(this.type === "edit") {
        this.uploadFileList_edit = this.uploadFileList_edit.filter(item => {
          const  status = file.url !== item.url;
          return status
        })
      }
    },

    // 文件上传超出限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前最多上传9个文件，本次上传已经超过了限制。`);
    },

  },

};
</script>

<style lang="stylus">
@import '~@/assets/css/variable'
.mediaFormWrap
  height 100%
  padding 20px 0 20px 20px
  .link
    padding-bottom 15px
    .link_col
      text-align center
  .demo-form-inline
    padding-right 30px
  .el-form-item__label
    color white
    font-size 16px
  .upload-demo
    .is-success
      &:hover
        color #4cd964
    .el-upload-list__item-name
      color #4cd964
    .el-progress-bar__inner
      background-color #4cd964
    .el-progress__text
      color #4cd964
.btn_wrap_media
  width 100%
  display flex
  justify-content center
</style>
